export default __webpack_public_path__ + "static/la-at-night-bg-0c60cd1db9c7216dada76cdfba0151b3.jpg";